/**
 * @file Help.jsx
 * @description Main application interface with role-specific features
 * 
 * @section Responsibilities
 * - Manage role-based views
 * - Handle data aggregation
 * - Control real-time updates
 * - Manage user preferences
 * 
 * @section Dependencies
 * - Role Management: Access control
 * - Data Services: Information handling
 * - State Management: Global state
 * 
 * @section Integration Points
 * - Data API: Information retrieval
 * - Role System: Access control
 * - Notification System: Real-time updates
 * 
 * @section State Management
 * - dashboardData: Aggregated information
 * - loadingState: Data fetching
 * - errorState: Error handling
 * 
 * @section Events
 * - onDataUpdate: Data changes
 * - onError: Error handling
 * - onPreferenceChange: Settings updates
 * 
 * @section Props
 * @prop {String} userRole - Current user role
 * @prop {Object} permissions - User permissions
 */

import React from 'react'
import Widget from '../Widget';
import FQA from '../../../../components/dashboard/FQA';

function Help({ width }) {
    return (
        <Widget name={"help"} width={width}>
            <div className="heading">
                <h2 className='title'>Need Help?</h2>
                <p className='subtitle'>Ask us anything</p>
                <div className="fqa">
                    <h5 className='title'>FQA</h5>
                    <input type="text" placeholder='Search for help' />
                    <img src="/assets/icons/search-blue.svg" alt="" />
                </div>
                <div className="contact-us">
                    <p>Contact us</p>
                    <img src="/assets/icons/chevron-down.svg" alt="" />
                </div>
            </div>
        </Widget>
    )
}

export default Help